export const uploadSchoolInfoRules = {
	schoolInfo: { required: true, accept: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'] },
}